// © Microsoft Corporation. All rights reserved.

import { AppError, logger } from "@msnews/diagnostics";

class AppErrorLogger {
    public onAppError: ((AppError) => void) = undefined;

    public log(error: AppError): void {
        if (this.onAppError) {
            try {
                this.onAppError(error);
            } catch (e) {
                logger.logError(e);
            }
        }
    }

    public setOnAppError(onAppError: ((AppError) => void)): void {
        this.onAppError = onAppError;
    }
}

export const appErrorLogger = new AppErrorLogger();